import { render } from "./ProductDetails.vue?vue&type=template&id=08bf228e&scoped=true"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"

import "./ProductDetails.vue?vue&type=style&index=0&id=08bf228e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bf228e"]])

export default __exports__